import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { registerPwa } from "./lib/pwa";
import "./styles/app.css";

registerPwa();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter basename="/crm-autodialer/app">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
